export default __webpack_public_path__ + "static/media/trade-4.391b672b.svg";